import { Button, Col, Form, Input, Row, notification } from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";

const Supplier = ({ history, match }) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();

	useEffect(() => {
		getSupplier();
	}, []);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const getSupplier = async () => {
		try {
			let url = api + `/supplier/get/${match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			if (data.success) {
				const payload = data.payload;
				setInitialValues({
					...initialValues,
					name: payload.name,
				});
				setLoading(false);
				setLoadingForm(false);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get supplier");
			console.error(err.message);
			return null;
		}
	};

	const updateSupplier = async (data) => {
		const supplier = {
			name: data.name,
		};

		try {
			const url = api + `/supplier/update/${match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.patch(url, supplier);
			if (data.success) {
				openNotification("success", "Success", "Supplier updated");
				setTimeout(() => {
					setLoading(false);
					history.push("/supplier/list");
				}, 2000);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to update supplier"
			);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		updateSupplier(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				initialValues={initialValues}
				onFinish={onFinish}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							size="large"
						>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Layout title="Supplier" description="Edit Supplier" type="medium">
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default Supplier;
